import { Box, Divider, Grid2, Typography } from "@mui/material";
import SeverityBadge from "../../BmsFaults/Badges/SeverityBadge";
import LevelBadge from "../../BmsFaults/Badges/LevelBadge";
import StatusBadge from "../../BmsFaults/Badges/StatusBadge";
import AlertCategoryBadge from "../../BmsFaults/Badges/AlertCategoryBadge";
import { convertAndGetTimeStampInRequiredFormat, getMetricTimeStamp } from "../../../Helper/DatePicker/DateConverter";
import { PrimaryTooltip } from "../../../Components/StyledComponent";
import OverdueBadge from "../../BmsFaults/Badges/OverdueBadge";
import dayjs from "dayjs";
import { getFormattedResolutionTime } from "../../../Helper/DatePicker/DateFormatters";

const CustomAlertListItemIncident = ({ selectedTab, alertIncident }) => {
    const { incidentErrorName, severity, severityLevel, bmsAlertStatus, category, customerDBTimeInsert, entityAffectedDisplayID, entityAffected, resolveCustomerDBTime = null, resolutionTime = null, overdueSince } = alertIncident;
    const triggeredOn = convertAndGetTimeStampInRequiredFormat(customerDBTimeInsert, "DD MMM'YY, hh:mm A");
    const relativeTriggeredOn = getMetricTimeStamp(customerDBTimeInsert, 'relative');
    const diffInDays = dayjs().diff(dayjs(convertAndGetTimeStampInRequiredFormat(customerDBTimeInsert)), "days");
    const showOverDueBadge = selectedTab === 'active' && diffInDays > 7;

    let resolvedOn = null;
    let relativeResolvedOn = null;
    if (resolveCustomerDBTime) {
        resolvedOn = convertAndGetTimeStampInRequiredFormat(resolveCustomerDBTime, "DD MMM'YY, hh:mm A");
        relativeResolvedOn = getMetricTimeStamp(resolveCustomerDBTime, 'relative');
    }

    let resolvedDuration = null;
    if (resolutionTime) {
        resolvedDuration = getFormattedResolutionTime(resolutionTime);
    }

    return (
        <Box
            sx={{
                bgcolor: severity.toLowerCase() === 'critical' ? '#FFF3F3' : '#F9F9F9',
                px: 2.5,
                py: 2,
                borderRadius: '3px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                border: '1px solid transparent',
                "&:hover": {
                    borderColor: '#D4D5FC'
                }
            }}
        >
            <Grid2 container gap={5} width={'100%'}>
                <Grid2 container flexDirection={'column'} justifyContent={'space-between'} alignItems={'flex-start'} gap={1} pt={0.75}>
                    <PrimaryTooltip
                        title={`Triggered ${relativeTriggeredOn}`}
                        placement="bottom"
                    >
                        <Typography variant="fw500s14c494949" sx={{ lineHeight: '20px' }}>{triggeredOn}</Typography>
                    </PrimaryTooltip>
                    {showOverDueBadge && <OverdueBadge overdueSince={overdueSince} />}
                </Grid2>
                <Grid2 container flexDirection={'column'} gap={1} flex={1}>
                    <Grid2 container alignItems={'center'} justifyContent={'space-between'}>
                        <Grid2 container gap={1.5} alignItems={'center'}>
                            <Typography variant="fw500s16lh20c000000">{incidentErrorName}</Typography>
                            <SeverityBadge severity={severity} />
                            {severityLevel && <LevelBadge level={severityLevel} />}
                        </Grid2>
                        <Grid2 container gap={1} alignItems={'center'}>
                            {bmsAlertStatus && <StatusBadge status={bmsAlertStatus} />}
                        </Grid2>
                    </Grid2>
                    <Grid2 container gap={1.5}>
                        <AlertCategoryBadge category={category} />
                        <Divider orientation="vertical" flexItem sx={{ borderColor: "#E4E4E4", my: 0.75 }} />
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Typography variant="fw400s14c8F8F8F" sx={{ color: '#686868', lineHeight: '20px' }}>Entity Affected:</Typography>
                            <Typography variant="fw500s14c494949" sx={{ lineHeight: '20px', textTransform: 'capitalize' }}>{entityAffected?.toLowerCase() === 'tms' ? 'TMS' : entityAffectedDisplayID}</Typography>
                        </Box>
                        {resolvedOn && (
                            <>
                                <Divider orientation="vertical" flexItem sx={{ borderColor: "#E4E4E4", my: 0.75 }} />
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <Typography variant="fw400s14c8F8F8F" sx={{ color: '#686868', lineHeight: '20px' }}>Resolved On:</Typography>
                                    <PrimaryTooltip
                                        title={relativeResolvedOn}
                                        placement="bottom"
                                    >
                                        <Typography variant="fw500s14c494949" sx={{ lineHeight: '20px', textTransform: 'capitalize' }}>{resolvedOn}</Typography>
                                    </PrimaryTooltip>
                                </Box>
                            </>
                        )}
                        {resolutionTime ? (
                            <>
                                <Divider orientation="vertical" flexItem sx={{ borderColor: "#E4E4E4", my: 0.75 }} />
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <Typography variant="fw400s14c8F8F8F" sx={{ color: '#686868', lineHeight: '20px' }}>Resolution Time:</Typography>
                                    <Typography variant="fw500s14c494949" sx={{ lineHeight: '20px', textTransform: 'capitalize' }}>{resolvedDuration}</Typography>
                                </Box>
                            </>
                        ) : (<></>)}
                    </Grid2>
                </Grid2>
            </Grid2>
        </Box>
    );
};

export default CustomAlertListItemIncident;
